var scope_0 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/591bce53963706ded14621b8d6833562.js').default;
var scope_1 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f830e0e61a66c2d90d047445b60c7ed3.js').default;
var scope_3 = require('/vercel/path1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ff68d49572c6585170789085c98fef13.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    